import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';

export interface SearchErrorStateProps {
  onRetry: () => void;
  className?: string;
}

export function SearchErrorState({ onRetry, className }: SearchErrorStateProps) {
  return (
    <div
      role="alert"
      className={`w-full mt-3 flex flex-col gap-6 ${className ?? ''}`}
      data-testid={DataTestIdEnum.PROCEDURES_MODAL_ERROR_STATE_CONTAINER}
    >
      <span className="text-base font-gray-800">
        Não conseguimos carregar a busca agora. Verifique sua conexão e tente novamente.
      </span>
      <Button
        variant="default"
        color="primary"
        className="md:w-fit"
        onClick={onRetry}
        data-testid={DataTestIdEnum.PROCEDURES_MODAL_ERROR_STATE_RETRY_BUTTON}
      >
        Tentar novamente
      </Button>
    </div>
  );
}
